

const MorePermissionModal = ({ isOpen, onClose, title, permissions = [], onChange }) => {
  if (!isOpen) return null;

  const handleCheckboxToggle = (index) => {
    const updated = [...permissions];
    updated[index].is_enabled = updated[index].is_enabled === 2 ? 0 : 2;
    onChange(updated);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h3>{title}</h3>
          <button onClick={onClose} style={closeButtonStyle}>&times;</button>
        </div>
        <div>
          {permissions.map((perm, index) => (
            <label key={perm.label} style={{ display: 'block', margin: '8px 0' }}>
              <input
                type="checkbox"
                checked={perm.is_enabled === 2}
                onChange={() => handleCheckboxToggle(index)}
              />
              {' '}
              {perm.display_name}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.4)', display: 'flex',
  justifyContent: 'center', alignItems: 'center',
};

const modalStyle = {
  background: '#fff', padding: '20px', borderRadius: '8px',
  width: '300px', maxHeight: '80vh', overflowY: 'auto',
};

const headerStyle = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};

const closeButtonStyle = {
  background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer',
};

export default MorePermissionModal;
